<div class="flex flex-column gap-2 mb-1">
    @if (showSidebar) {
        <div class="flex gap-2 align-items-center" style="padding-right: 30px">

            <div class="p-inputgroup search-wrapper justify-content-center">
                <div class="flex align-items-center" >
                    <p-autoComplete class=""
                                    optionLabel="content"
                                    styleClass="w-18rem"
                                    [inputStyle]="{'width': '100%','height':'35px', 'border-top-right-radius': '0px','border-bottom-right-radius': '0px'}"
                                    [inputStyleClass]="'border-400'"
                                    panelStyleClass="w-18rem overflow-auto"
                                    [delay]="500"
                                    (completeMethod)="search($event)"
                                    (onSelect)="selectContent($event)"
                                    [suggestions]="suggestions"
                                    [showClear]="true"
                                    [(ngModel)]="value"
                                    emptyMessage="Not Found"
                                    placeholder="Search...">
                    </p-autoComplete>

                    <!--                <span class="p-inputgroup-addon cursor-pointer hover:surface-100 border-400 flex align-items-center"-->
                    <!--                      style="height: 35px; border-right: 0; border-left: 0; border-radius: 0"-->
                    <!--                      pTooltip="Search in current directory" tooltipPosition="bottom">-->
                    <!--                             <p-checkbox  [binary]="true" variant="filled"-->
                    <!--                                         [checkboxIcon]="'fa-solid fa-file-check'"/>-->
                    <!--                            </span>-->
                </div>

                <span class="p-inputgroup-addon cursor-pointer border-400 flex align-items-center text-primary text-700"
                      style="height: 35px">
                            <i class="fa fa-search text-xl"></i>
                            </span>

            </div>


            <p-button styleClass="p-button-text bg-primary-50" icon="fa-regular fa-plus-circle" (onClick)="handleGeneralPageCreate()"></p-button>
<!--            <p-progressSpinner style="margin: inherit"-->
<!--                    *ngIf="busy"-->
<!--                    styleClass="w-2rem h-2rem"-->
<!--                    strokeWidth="3"-->
<!--            ></p-progressSpinner>-->
        </div>
    }

    <span class="sidebar-arrow surface-0 cursor" [ngClass]="showSidebar ? 'arrow-pos-open' : 'arrow-pos-collapsed'"
          (click)="toggleSidebar()"
    [pTooltip]="!showSidebar ? 'open sidebar' : 'collapse sidebar'" >
                  <i class="fa-regular text-color-secondary"
                     [ngClass]="showSidebar ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
            </span>
</div>

@if (showSidebar) {
    <p-tree
            [value]="files"
            filterPlaceholder="Search Item"
            selectionMode="single"
            [(selection)]="selectedNode"
            (onNodeSelect)="handleNodeSelect()"
            (onNodeExpand)="handleNodeExpand($event)"
            (onNodeUnselect)="handleUnNodeSelect()"
            [contextMenu]="cm"
            (onNodeContextMenuSelect)="handleContextMenu($event)"
            [trackBy]="trackByKey"
            [loading]="busy"
            styleClass="p-0 border-0">
    </p-tree>
    <p-contextMenu appendTo="body" #cm [model]="items"/>
}
